import React, { useEffect, useState } from 'react';
import PlanHeader from "./PlanHeader";
import PlanPackageCard from "./PlanPackageCard";
import "./Plan.css";
import { Helmet } from 'react-helmet';
import SEO from '../SEO';
import { db } from '../firebase'; // Import Firestore instance
import { collection, getDocs } from 'firebase/firestore';
import logo from "../img/Oglitz-main-icon.png";


const PlanPage = () => {
  const [designPackages, setDesignPackages] = useState([]);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "plansAndPricing"));
        const packagesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDesignPackages(packagesData);
      } catch (error) {
        console.error("Error fetching design packages: ", error);
      }
    };

    fetchPackages();
  }, []);

  const baseUrl = "https://www.oglitz.com";

  const schemaPackages = designPackages.map((pkg) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    name: pkg.title,
    image: pkg.logo[0], // Assuming the first logo is used as the main image
    description: pkg.description,
    keyFeatures: pkg.keyFeatures,
    benefits: pkg.benefits,
    moreInfo: pkg.moreInfo,
    offers: {
      "@type": "Offer",
      priceCurrency: "INR",
      price: pkg.price,
      itemCondition: "https://schema.org/NewCondition",
      url: `${baseUrl}${pkg.link}`,
      availability: "https://schema.org/InStock",
    },
    additionalType: "https://schema.org/Service",
    serviceType: pkg.benefits,
    provider: {
      "@type": "Organization",
      name: "Oglitz Software Pvt Ltd.",
      url: baseUrl,
    },
    additionalInformation: {
      duration: pkg.duration,
      whatsIncluded: pkg.whatsIncluded,
      moreInfo: pkg.moreInfo,
    },
    includedInPackage: pkg.whatsIncluded.map((item) => ({
      "@type": "PropertyValue",
      name: item.feature,
      value: item.detail,
    })),
    demoImages: pkg.logo.map((url) => ({
      "@type": "ImageObject",
      url: url,
    })),
  }));

  return (
    <div className="unique-design-page">
      <SEO
        title="Plans & Pricing | Oglitz Software Pvt Ltd."
        description="Explore affordable Plans & Pricing from Oglitz Software Pvt Ltd. Choose from tailored packages for websites, web apps, mobile apps, and complete digital solutions. Get the right plan to launch and grow your business today."
        image={logo} // Update with your actual image URL
        url={`${baseUrl}/plans-pricing`}
        keywords="website packages, app development pricing, software plans, affordable business solutions, web design packages, mobile app pricing, digital solutions, Oglitz Software Pvt Ltd., Oglitz Software"
        author="Oglitz Software Pvt Ltd."
        twitterHandle="@oglitz"
        schemaData={schemaPackages}
      />

      <header className="unique-header">
        <h1>Find the perfect plan for your business.</h1>
        <p>
          Choose from our flexible packages designed to fit your needs. Click
          “Request Order” to get started today.
        </p>
      </header>
      <div className="unique-packages-container">
        {designPackages.map((pkg) => (
          <PlanPackageCard key={pkg.id} packageData={pkg} />
        ))}
      </div>
    </div>
  );
};

export default PlanPage;
